import {Rox} from 'rox-ssr';

export enum LANDING_PAGES {
    home,
    category,
    product,
    cart,
    checkout,
    other,
}

export const LANDING_PAGE_NAMES = {
    [LANDING_PAGES.home]: 'HP',
    [LANDING_PAGES.category]: 'CTP',
    [LANDING_PAGES.product]: 'PDP',
    [LANDING_PAGES.cart]: 'Cart',
    [LANDING_PAGES.checkout]: 'Checkout',
    [LANDING_PAGES.other]: 'Other',
};

export type RoxCustomFieldsType = {
    geolocation?: string[];
    visitorId?: string;
    origin: string;
    ip?: string;
    landingUrl: string;
    landingPage?: string;
};

/**
 * Sets custom properties for rox flags
 * @param {Array<string>} geolocation - have to get location before calling this function
 * @param {string} visitorId - visitor ID
 * @param {string} origin - origin
 * @param {string} ip - IP address of the request
 * @param {string} landingUrl - url user lands
 * @param {string} landingPage - page user lands
 */
// eslint-disable-next-line max-statements
export const setCustomProperties = ({
    geolocation = [],
    visitorId = '',
    origin,
    ip = '',
    landingUrl,
    landingPage,
}: RoxCustomFieldsType) => {
    Rox.setCustomStringProperty('country', geolocation[0] || '');
    Rox.setCustomStringProperty('state', geolocation[1] || '');
    Rox.setCustomStringProperty('site', 'mobile-app');
    Rox.setCustomStringProperty('rox.distinct_id', visitorId);
    Rox.setCustomStringProperty('domain', origin);
    Rox.setCustomStringProperty('landingUrl', landingUrl);
    if (landingPage) Rox.setCustomStringProperty('landingPage', landingPage);

    // we don't have an ability to get ip on the client side on init application that's why it will work only on ssr
    if (ip) Rox.setCustomStringProperty('IP', ip);
};
